
<section *ngIf="isVisible" #modal class="custom-backdrop" [ngStyle]="customBackdropStyles">
  <article class="custom-modal" [ngStyle]="customModalStyles">
    <span (click)="close()" class="custom-modal__close"></span>
    <ng-content></ng-content>
  </article>
</section>
